import { render, staticRenderFns } from "./RegisterDetails.vue?vue&type=template&id=967ac610&scoped=true&"
import script from "./RegisterDetails.vue?vue&type=script&lang=js&"
export * from "./RegisterDetails.vue?vue&type=script&lang=js&"
import style0 from "./RegisterDetails.vue?vue&type=style&index=0&id=967ac610&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967ac610",
  null
  
)

export default component.exports